import React, { useEffect, useState } from "react";
import StudentImagePopup from "./StudentImageSlidePopup.component";
import { increaseStudentPhotoViewCount } from "api/agency/v2/Student.api";
import { usePopup } from "contexts/PopupContext";
import FullPageStudentInfoPopupContainer from "./FullPageStudentInfoPopup.container";
//* Params
//  profileImageInfo: 프로필 사진 정보(뷰 카운트 업데이트 필요 없는 사진)
//  userStudentImageList: 학생의 사진첩 사진(뷰 카운트 업데이트 필요한 사진)
//  initialSlideIdx: 초기 슬라이드 인덱스
//  onClose: 닫기 함수

//* 프로필 사진 구조
//  profileImageInfo = imageInfo

//* 사진첩 구조
//  userStudentImageList
//      imageInfo
//      id

const StudentImageSlidePopupContainer = (props: any) => {
    const { showPopup } = usePopup();
    const { profileImageInfo, userStudentImageList, initialSlideIdx, userStudentInfo, onClose } = props;
    const [isInit, setIsInit] = useState(false);
    const [slideIdx, setSlideIdx] = useState(-1);
    const [imageList, setImageList] = useState([]);

    useEffect(() => {
        console.log("agency/v2/popup/StudentImageSlidePopup.container:useEffect");
        console.log({ initialSlideIdx });
        console.log({ profileImageInfo });
        console.log({ userStudentImageList });

        const newImageList = [];
        if (profileImageInfo) {
            newImageList.push({ imageInfo: profileImageInfo });
        }

        if (userStudentImageList?.length > 0) {
            newImageList.push(...userStudentImageList);
        }
        setImageList(newImageList);
    }, []);

    useEffect(() => {
        console.log('imageList', imageList);
        setSlideIdx(initialSlideIdx);
        setIsInit(true);
    }, [imageList]);

    useEffect(() => {
        console.log('slideIdx', slideIdx);
        if (slideIdx >= 0) {
            increasePhotoViewCount();
        }
    }, [slideIdx]);

    const increasePhotoViewCount = async () => {
        console.log('increasePhotoViewCount');
        console.log({ slideIdx });
        console.log({ imageList });
        const imageInfo = imageList[slideIdx];
        console.log('imageInfo', imageInfo);
        if (!imageInfo) {
            return;
        } else if (!imageInfo?.id) {
            return;
        }

        try {
            const userStudentImageId = imageInfo?.id;
            await increaseStudentPhotoViewCount(userStudentImageId);
        } catch (error) {
            console.error('Failed to increase photo view count:', error);
        }
    }

    const handleStudentInfoPopup = (userStudentId: number) => {
        showPopup(
          <FullPageStudentInfoPopupContainer
            userStudentId={userStudentId}
          />
        );
      }

    return <StudentImagePopup
        imageList={imageList}
        slideIdx={slideIdx}
        setSlideIdx={setSlideIdx}
        userStudentInfo={userStudentInfo}
        onClose={onClose}
        isInit={isInit}
        handleStudentInfoPopup={handleStudentInfoPopup}
    />;
};

export default StudentImageSlidePopupContainer;
